import React from 'react';

import {
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
} from '@material-ui/core';
import SentimentVeryDissatisfiedIcon from '@material-ui/icons/SentimentVeryDissatisfied';
import SentimentVerySatisfiedIcon from '@material-ui/icons/SentimentVerySatisfied';
import PropTypes from 'prop-types';
import { can } from '~/helpers';
import { t, number } from '~/helpers';
import { MODULO_CUSTOMIZACAO_VLI } from '~/constants/modules';
import * as S from './styles';

function TabelaResumoSLA({ d1, mes, ano, data }) {

  const atendimentosPendentesAprovacaoAdm = Number(data?.[0]?.atendimentospendentesaprovacaoadm ?? 0) || 0;
  const itensExcecaoMetaMes = Number(data?.[0]?.itensexcecaometames ?? 0) || 0;
  const itensExcecaoMetaAno = Number(data?.[0]?.itensexcecaometaano ?? 0) || 0;

  function renderFarolCell(totalMes, percentualMes) {
    if (totalMes === 0) {
      return <TableCell className="FarolCell">-</TableCell>;
    }

    const percentual = Math.abs(Math.round(percentualMes * 100));

    return (
      <TableCell className="FarolCell">
        {percentual > 8800 ? (
          <SentimentVerySatisfiedIcon
            style={{ color: '#57d9a3', fontSize: 24 }}
          />
        ) : (
          <SentimentVeryDissatisfiedIcon
            style={{ color: '#ff7452', fontSize: 24 }}
          />
        )}
      </TableCell>
    );
  }

  function renderPercentualCell(total, percentual) {
    if (total === 0) {
      return <TableCell>-</TableCell>;
    }

    const perc = Math.abs(Math.round(percentual * 100));

    return (
      <TableCell className={perc <= 8800 ? 'cell-danger' : 'cell-success'}>
        {number(percentual, 2)}
      </TableCell>
    );
  }

  return (
    <S.WrapperTable>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table" size="small">
          <TableHead>
            <TableRow>
              <TableCell rowSpan="2">
                {t('s.indicadoroperacao.farol')}
              </TableCell>
              <TableCell rowSpan="2">
                {t('s.menu.configuracao.posto')}
              </TableCell>
              <TableCell colSpan="4">
                {`${t('s.indicadoroperacao.variacaod1')} (${d1})`}
              </TableCell>
              <TableCell colSpan="4">{`${t(
                's.indicadoroperacao.variacaomes'
              )} (${mes})`}</TableCell>
              <TableCell colSpan="4">{`${t(
                's.indicadoroperacao.variacaoano'
              )} (${ano})`}</TableCell>
            </TableRow>
            <TableRow>
              {Array(3)
                .fill([
                  'Todos',
                  `<= ${t('s.cadastro.pitstop.slaatendimento')}`,
                  `> ${t('s.cadastro.pitstop.slaatendimento')}`,
                  `% ${t('s.cadastro.pitstop.slaatendimento')}`,
                ])
                .flat()
                .map((header, i) => (
                  <TableCell key={i}>{header}</TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row) => (
              <TableRow
                key={row.postodesc}
                className={!row.idposto ? 'row-gray' : ''}
              >
                {renderFarolCell(row.totalmes, row.percentualmes)}
                <TableCell className="PostoCell">{row.postodesc}</TableCell>
                <TableCell>{row.totald1.toLocaleString()}</TableCell>
                <TableCell>{row.menorigualslad1.toLocaleString()}</TableCell>
                <TableCell>{row.maiorslad1.toLocaleString()}</TableCell>
                {renderPercentualCell(row.totald1, row.percentuald1)}
                <TableCell>{row.totalmes.toLocaleString()}</TableCell>
                <TableCell>{row.menorigualslames.toLocaleString()}</TableCell>
                <TableCell>{row.maiorslames.toLocaleString()}</TableCell>
                {renderPercentualCell(row.totalmes, row.percentualmes)}
                <TableCell>{row.totalano.toLocaleString()}</TableCell>
                <TableCell>{row.menorigualslaano.toLocaleString()}</TableCell>
                <TableCell>{row.maiorslaano.toLocaleString()}</TableCell>
                {renderPercentualCell(row.totalano, row.percentualano)}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {can(MODULO_CUSTOMIZACAO_VLI) && (
        <S.ResumoIndicadores>
          <p>Número de SLAs com pendência de aprovação pela Administração:{' '} {atendimentosPendentesAprovacaoAdm.toLocaleString('pt-BR')}</p>
          <p>Itens de exceção meta do mês: {itensExcecaoMetaMes.toLocaleString('pt-BR')}</p>
          <p>Itens de exceção meta do ano: {itensExcecaoMetaAno.toLocaleString('pt-BR')}</p>
        </S.ResumoIndicadores>
      )}
    </S.WrapperTable>
  );
}

TabelaResumoSLA.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  d1: PropTypes.string.isRequired,
  mes: PropTypes.string.isRequired,
  ano: PropTypes.string.isRequired,
};

export default TabelaResumoSLA;
